/* eslint-disable */

import { isString, some } from "lodash";
import { getResxWithBrandName } from "../common/branding";
import "../EasyProjects/ActivityList/ErrorManager";
import { commonResx } from "../resxDist/commonResx";
import { parseJsonWithDate, parseJsonWithSchema } from "../utils/json";
import { ResponseErrorTypes } from "./EpEnums";
import { RequestAntiForgeryHelper, verificationTokenKey } from "./RequestAntiForgeryHelper";
import { ServerVersionHelper } from "./ServerVersionHelper";
import { addSessionIdHeader } from "./Session";
import { trim } from "./General.js"

let epCommon;
export const ajaxObjectNotFoundEvent = "ajax/objectnotfoundevent";

window.ep = window.ep || {};
(function(ep, jQuery) {

    var postingDataPostProcessors = [];

    var postProcessPostingData = function(data){
        if(!postingDataPostProcessors.length)
            return data;

        data = data || {};
        if(typeof data !== 'object')
            return data;

        for (var i = 0; i < postingDataPostProcessors.length; i++) {
            postingDataPostProcessors[i] (data);
        }

        return data;
    };

    var responsePreProcessors = [];

    var preProcessResponse = function(response, request, url){
        if(!responsePreProcessors.length)
            return;

        if(!response || typeof response !== 'object')
            return;

        var e = {
            response: response,
            url: url,
            request: request
        };

        for (var i = 0; i < responsePreProcessors.length; i++) {
            responsePreProcessors[i](e);
        }
    };

    ep.common = ep.common || {};

    var objectNotFoundEvent = null;

    /**
     * @returns {ep.common.EventWrapper}
     */
    var getObjectNotFoundEventInstance = function(){
        if(!objectNotFoundEvent){
            objectNotFoundEvent = new ep.common.EventWrapper(ajaxObjectNotFoundEvent);
        }
        return objectNotFoundEvent;
    };

    ep.common.publishObjectNotFound = function({ entityName, objectKey, eventSource = null }){
        if(isString(objectKey)){
            objectKey = parseInt(objectKey);
        }
        getObjectNotFoundEventInstance().notify({
            entityName,
            objectKey,
            eventSource,
            isTask: entityName === "Task",
            isProject: entityName === "Project"
        });
    };

    /**
     * @returns {ep.common.EventWrapper}
     */
    ep.common.objectNotFoundEvent = function(){
        return getObjectNotFoundEventInstance().getPublicInterface();
    };

    /* Error handling  */

    ep.common.buildAjaxErrorHandler = function(customHandlers) {
        return function (request) {
            if (request.statusText == "abort") {
                return;
            }

            var responseText = (request.responseTextFromBlob != undefined && request.responseTextFromBlob != null) ? request.responseTextFromBlob : request.responseText;
            responseText = responseText || "{}";
            var response = {};
            try {
                response = JSON.parse(responseText);
            }catch(e) {
                //ignore errors because sometimes response might be html (for example on unauthorized response)
            }

            if (this.ignoreErrors || (this.ignoreErrorsList && some(this.ignoreErrorsList, e => response.ErrorType===e ))) {
                return;
            }

            //reloads current page if request was for not authorized user (as result server redirects to login page)
            if (request.status === 401) {
                if (!this.ignoreUnauthorizedError) {
                    // let handle error for subscribers
                    // i.e. ep.common.postJson(...).fail(...);
                    // so postponed a bit page reloading.
                    setTimeout(() => location.reload());
                }
                return;
            }

            //change response to empty object in response empty because JSON.parse fails on empty string (in ie8 and maybe in other browsers too)

            var defaultHandler = function () {
                if (response.ErrorPageUrl != undefined) {
                    jQuery(window).unbind();
                    window.location = response.ErrorPageUrl;
                }
            };

            var isHandled = false;
            if (customHandlers && customHandlers.length) {
                var ctx = this;
                isHandled = some(customHandlers, function (customHandler) {
                    return customHandler.call(ctx, response);
                });
            }

            if (!isHandled) {
                if (response.ErrorType === ResponseErrorTypes.ObjectNotFound) {

                    var objectInfo = {
                        entityName: response.EntityName,
                        objectKey: response.ObjectKey,
                        dialogOnCloseCallback: this.errorDialogOnCloseCallback
                    };
                    var needToNotify = ep.errorManager.handleObjectNotFoundError(objectInfo);
                    if (needToNotify)
                        ep.common.publishObjectNotFound(objectInfo);
                } else if (response.ErrorType === ResponseErrorTypes.UserFriendlyError) {
                    const msg = (response.ErrorKey && getResxWithBrandName(commonResx[response.ErrorKey])) || response.Message;
                    ep.errorManager.handleUserFriendlyError(msg, this.errorDialogOnCloseCallback);
                } else if (response.ErrorType === ResponseErrorTypes.UpgradePlanRequired) {
                    ep.upgradePlanHelper.showWindowForFeature(response.Feature);
                } else if (response.ErrorType === ResponseErrorTypes.ServerVersionException) {
                    ep.errorManager.handleServerVersionError();
                }
                else if (request.status == 504 /** gateway timeout */) {
                    ep.errorManager.handleTimeoutError();
                }
                else if (request.status === 403 || request.status === 404 || request.status === 400 || response.ErrorType === ResponseErrorTypes.UnknownError ) {
                    ep.errorManager.handleUnknownError();
                }
                else if (request.status == 200 && request.getResponseHeader("Content-Type").toLowerCase().indexOf("text/html") >= 0) {
                    // jQuery loses the 302 status code for redirects and processes the response as 200,
                    // then fails to parse json if the server returns raw html.
                    // Assume that if text/html is returned when we're expecting JSON, the user is most likely being redirected
                    // (e.g., a guest user is redirected to the guest portal when calling a forbidden API in epcore)
                    // ep.errorManager.handleRedirectResult();
                }
                else {
                    defaultHandler();
                }
            }
        }
    };

    ep.common.onAjaxError = ep.common.buildAjaxErrorHandler(null);

    // overriding Date.toJSON to serialize local time (original implementation serializes UTC time)
    // we could use replacer parameter of JSON.stringify but unfortunately it calls toJSON first
    Date.prototype.toJSON = function () {
        if (!isFinite(this.valueOf())) {
            return null;
        }
         // trimming the time part away because dateParser/date select returns dates with time
        return new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate())).toISOString();
    };

    Date.prototype.toJSONWithTime = function () {
        if (!isFinite(this.valueOf())) {
            return null;
        }

        return new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds())).toISOString();
    };

    ep.common.jsonStringify = function (data) {
        return JSON.stringify(data);
    };

    ep.common.addAjaxPostingDataPostProcessor = function(postProcessor){
        postingDataPostProcessors.push(postProcessor);

        return () => {
            postingDataPostProcessors = postingDataPostProcessors.filter(x => x != postProcessor);
        }
    };

    ep.common.addResponsePreProcessor = function(preProcessor){
        responsePreProcessors.push(preProcessor);

        return () => {
            responsePreProcessors = responsePreProcessors.filter(x => x != preProcessor);
        }
    };

    if(ep.testsEnv){
        ep.common.preProcessReponse = preProcessResponse;

        ep.common.clearResponsePreProcessors = function(){
            responsePreProcessors = [];
        };
    }

    ep.common.get = function (url, data, callback, optionalParams) {
        // shift arguments if data argument was omitted
        if (jQuery.isFunction(data)) {
            optionalParams = optionalParams || callback;
            callback = data;
            data = undefined;
        }

        optionalParams = optionalParams || {};
        return ep.common.ajax({
            url: url,
            type: "get",
            dataType: optionalParams.type,
            data: data,
            success: callback,
            skipPostProcess: optionalParams.skipPostProcess
        });
    };

    ep.common.post = function (url, data, callback, type, onError) {
        // shift arguments if data argument was omitted
        if (jQuery.isFunction(data)) {
            type = type || callback;
            callback = data;
            data = undefined;
        }

        return ep.common.ajax({
            url: url,
            type: "post",
            dataType: type,
            data: data,
            success: callback,
            error: onError
        });
    };

    ep.common.ajax = function (options) {
        if (options.error === undefined) {
            options.error = ep.common.onAjaxError;
        }

        if (!options.skipPostProcess){
            options.data = postProcessPostingData(options.data);
        }
        options.headers = { "X-TimeZoneOffset": -(new Date().getTimezoneOffset()) + '' }; // todo: post time zone offset only if changed

        return jQuery.ajax(options)
                     .done(function(response){
                        preProcessResponse(response, options.data, options.url);
                     });
    };

    var lazyPromises = {};

    ep.common.repostJson = function (url, data, callback, optionalParams) {
        if (!url) {
            throw new Error('url argument is required');
        }

        if (lazyPromises[url])
            lazyPromises[url].abort();

        var promise = ep.common.postJson(url, data, callback, optionalParams)
                               .always(function () {
                                   lazyPromises[url] = null;
                               });

        lazyPromises[url] = promise;

        return promise;
    }

    var setOptionalParams = function (options, optionalParams) {
        if (optionalParams.needIgnoreAccountActivity) {
            Object.assign(options.headers, { "NeedIgnoreAccountActivity": true })
        }

        if (optionalParams.headers) {
            Object.assign(options.headers, optionalParams.headers)
        }

        if (optionalParams.errorDialogOnClose) {
            Object.assign(options, { errorDialogOnCloseCallback: optionalParams.errorDialogOnClose });
        }

        if (optionalParams.ignoreErrors) {
            Object.assign(options, { ignoreErrors: optionalParams.ignoreErrors });
        }

        if (optionalParams.ignoreUnauthorizedError) {
            Object.assign(options, {ignoreUnauthorizedError: optionalParams.ignoreUnauthorizedError});
        }

        if (optionalParams.ignoreErrorsList) {
            Object.assign(options, {ignoreErrorsList: optionalParams.ignoreErrorsList});
        }
    };

    ep.common.postJson = function(url, data, callback, optionalParams) {
        return ep.common.send('POST', url, data, callback, optionalParams);
    };

    ep.common.send = function(method, url, data, callback, optionalParams) {
        optionalParams = optionalParams || {};

        // shift arguments if data argument was omitted
        if (jQuery.isFunction(data)) {
            callback = data;
            data = undefined;
        }

        if (method !== "GET") {
            data = postProcessPostingData(data);
        }

        var customErrorHandlers = [];
        var errorHandler = ep.common.buildAjaxErrorHandler(customErrorHandlers);

        var options = {
            url: url,
            type: method,
            contentType: 'application/json; charset=utf-8',
            data: (data && typeof data !== 'string') ? ep.common.jsonStringify(data) : data, // serializing data with own serializer
            dataType: 'json',
            converters: {"text json": optionalParams.responseSchema ? parseJsonWithSchema(optionalParams.responseSchema) : parseJsonWithDate}, // overriding standard jQuery json parser
            success: callback,
            error: errorHandler,
            headers: {
                "X-TimeZoneOffset": -(new Date().getTimezoneOffset()) + '' // todo: post time zone offset only if changed
            },
            optionalParams: optionalParams
        };

        setOptionalParams(options, optionalParams);

        var xhr = jQuery.ajax(options)
            .done(function(response){
                preProcessResponse(response, data, url);
            });

        xhr.addErrorHandler = function(callback){
            customErrorHandlers.unshift(callback);
            return this;
        };

        return xhr;
    };

    ep.common.downloadFile = function(url, data, filename, onLoadCompleted, optionalParams = {}){
        const deferred = $.Deferred();

        const request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        request.setRequestHeader("X-TimeZoneOffset", -(new Date().getTimezoneOffset()) + '')
        request.responseType = 'blob';

        const options = { headers: {}};
        setOptionalParams(options, optionalParams);

        request.onload = function () {
            if (onLoadCompleted){
                onLoadCompleted();
            }

            if (request.status === 200) {
                var name = filename;

                if(!name){

                    //The filename*=  IETF RFC 5987 encoding. The filename= and filename*= properties differ only in that
                    //filename*= uses the encoding defined in IETF RFC 5987, allowing the use of characters not present in the ISO-8859-1 character set.
                    //so to get correct non ISO-8859-1 filename we should use filename* when provided
                    //https://docs.microsoft.com/en-us/dotnet/api/system.net.http.headers.contentdispositionheadervalue.filenamestar?redirectedfrom=MSDN&view=netframework-4.8#System_Net_Http_Headers_ContentDispositionHeaderValue_FileNameStar
                    const disposition = request.getResponseHeader('content-disposition');

                    const filenameStarMatches = /filename\*[^;=\n]*=UTF-8'.*?'([^;\n]*)/.exec(disposition);
                    name = filenameStarMatches != null && filenameStarMatches[1] ? decodeURIComponent(filenameStarMatches[1]) : null;

                    if(!name){
                         const filenameMatches = /filename[^\*;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                         name =  filenameMatches != null && filenameMatches[1] ? filenameMatches[1] : 'file';
                    }

                    // server wrap filename in double quotes if there are spaces in it (e.g. attachment; filename="test name.csv")
                    if(name){
                        name = trim(name, '"');
                    }
                }

                const responseType = request.getResponseHeader('content-type');

                sendBlob(request, name, responseType);

                deferred.resolve();
            }
            else{
                var reader = new FileReader();

                reader.onload = () => {
                    const responseText = reader.result;
                    request.responseTextFromBlob = responseText;
                    ep.common.onAjaxError.call(options, request);

                    deferred.reject(request);
                };

                reader.readAsText(request.response);
            }
        };

        for (let key in options.headers){
            request.setRequestHeader(key, options.headers[key])
        }
        request.send((data && typeof data !== 'string') ? ep.common.jsonStringify(data) : data);
        return deferred;
    };

    const sendBlob = (request, name, responseType) => {
        // if IE11
        if (typeof window.navigator.msSaveBlob === 'function') {
            window.navigator.msSaveBlob(request.response, name);
        }
        else {
            const blob = new Blob([request.response], { type: responseType });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const getFormDataForMultipartPost = (data) => {
        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        return formData;
    };

    ep.common.postMultipart = (url, data, optionalParams = {}) => {
        let formData = getFormDataForMultipartPost(data);
        var options = {
            url: url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
            error: ep.common.onAjaxError,
            headers: {
                "X-TimeZoneOffset": -(new Date().getTimezoneOffset()) + '' // todo: post time zone offset only if changed
            },
            optionalParams: optionalParams
        };

        setOptionalParams(options, optionalParams);

        return jQuery.ajax(options)
            .done(function(response){
                preProcessResponse(response, data, url);
            });
    };

    (function(){
        jQuery.ajaxPrefilter(function (options, originalOptions, jqXHR){
            RequestAntiForgeryHelper.setAntiForgeryToken(options);
            ServerVersionHelper.setServerVersion(options);
            addSessionIdHeader(options);
        });

        let origSubmit  =  HTMLFormElement.prototype.submit;
        HTMLFormElement.prototype.submit = function () {
            let tokenField = jQuery(`input[name=${verificationTokenKey}]`, this);
            if(!tokenField.length) {
                jQuery(this).append(RequestAntiForgeryHelper.getAntiForgeryField());
            } else {
                tokenField.val(RequestAntiForgeryHelper.getAntiForgeryToken());
            }

            return origSubmit.apply(this, arguments);
        };
    })();

    epCommon = ep.common;
})(ep, jQuery);

export  {epCommon};
/* eslint-enable */
